import { useState } from "react";
import { useNavigate } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE_URL || `${process.env.FRONTEND_URL}/api`;

export default function AuthPage() {
  const [tab, setTab] = useState("login");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const [loginData, setLoginData] = useState({ email: "", password: "" });
  const [registerData, setRegisterData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
  });

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${API_BASE}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(loginData),
      });
      const json = await res.json();
      if (!json.success) throw new Error(json.error.message);
      localStorage.setItem("token", json.data.token);

      const role = json.data.user.role;
      if (role === "AGENT") {
        navigate("/agent/applications");
      } else {
        navigate("/portal/dashboard");
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${API_BASE}/auth/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(registerData),
      });
      const json = await res.json();
      if (!json.success) throw new Error(json.error.message);
      localStorage.setItem("token", json.data.token);
      navigate("/portal/dashboard");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-[#f7f9fb] font-['Plus_Jakarta_Sans'] min-h-screen flex items-center justify-center">
      <main className="w-full max-w-[480px] px-4 py-12">
        <div className="flex flex-col items-center mb-8">
          <div className="flex items-center gap-2 mb-2">
            
            <img src="/images/logo_w_nobg.png" alt="IASC Consultancy" className="h-10 w-10 object-contain rounded-lg" />
            <h1 className="text-2xl font-bold tracking-tight text-[#00255a]">
              <a href="/">IASC Consultancy</a>
            </h1>
          </div>
          <p className="text-[#64748b] text-sm uppercase tracking-widest">
            Global Opportunity Portal
          </p>
        </div>

        <div className="bg-white rounded-xl shadow-[0px_10px_30px_rgba(30,60,114,0.05)] border border-[#e2e8f0] p-8 md:p-10">
          <div className="flex border-b border-[#e2e8f0] mb-8">
            <button
              className={`flex-1 py-4 text-sm font-semibold transition-all ${tab === "login" ? "text-[#00255a] border-b-2 border-[#00255a]" : "text-[#64748b]"}`}
              onClick={() => setTab("login")}
            >
              Login
            </button>
            <button
              className={`flex-1 py-4 text-sm font-semibold transition-all ${tab === "register" ? "text-[#00255a] border-b-2 border-[#00255a]" : "text-[#64748b]"}`}
              onClick={() => setTab("register")}
            >
              Create Account
            </button>
          </div>

          {error && (
            <div className="mb-6 p-3 bg-red-50 border border-red-200 text-red-700 text-sm rounded-lg">
              {error}
            </div>
          )}

          {tab === "login" ? (
            <form className="space-y-6" onSubmit={handleLogin}>
              <FloatingInput
                type="email"
                label="Email Address"
                required
                value={loginData.email}
                onChange={(v) => setLoginData({ ...loginData, email: v })}
              />
              <FloatingInput
                type="password"
                label="Password"
                required
                value={loginData.password}
                onChange={(v) => setLoginData({ ...loginData, password: v })}
              />
              <div className="flex items-center justify-between">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    className="w-4 h-4 rounded border-[#e2e8f0] text-[#00255a]"
                  />
                  <span className="text-sm text-[#64748b]">Remember me</span>
                </label>
                <a
                  className="text-sm text-[#365da3] hover:text-[#00255a]"
                  href="#forgot-access"
                >
                  Forgot Password?
                </a>
              </div>
              <SubmitButton
                loading={loading}
                label="Access Portal"
                icon="arrow_forward"
              />
            </form>
          ) : (
            <form className="space-y-6" onSubmit={handleRegister}>
              <div className="grid grid-cols-2 gap-4">
                <FloatingInput
                  type="text"
                  label="First Name"
                  required
                  value={registerData.firstName}
                  onChange={(v) =>
                    setRegisterData({ ...registerData, firstName: v })
                  }
                />
                <FloatingInput
                  type="text"
                  label="Last Name"
                  required
                  value={registerData.lastName}
                  onChange={(v) =>
                    setRegisterData({ ...registerData, lastName: v })
                  }
                />
              </div>
              <FloatingInput
                type="email"
                label="Email Address"
                required
                value={registerData.email}
                onChange={(v) => setRegisterData({ ...registerData, email: v })}
              />
              <FloatingInput
                type="password"
                label="Create Password"
                required
                value={registerData.password}
                onChange={(v) =>
                  setRegisterData({ ...registerData, password: v })
                }
              />
              <div className="p-4 bg-[#f2f4f6] rounded-lg border border-[#e2e8f0] flex gap-3 items-start">
                <span className="material-symbols-outlined text-[#00255a]">
                  info
                </span>
                <p className="text-sm text-[#44474f] leading-relaxed">
                  Applying for both study and work opportunities? One account
                  covers both.
                </p>
              </div>
              <SubmitButton
                loading={loading}
                label="Begin Application"
                icon="how_to_reg"
              />
            </form>
          )}
        </div>

        <footer className="mt-8 flex flex-wrap justify-center gap-x-8 gap-y-2">
          <a
            className="text-sm text-[#64748b] hover:text-[#00255a]"
            href="/privacy"
          >
            Privacy Policy
          </a>
          <a
            className="text-sm text-[#64748b] hover:text-[#00255a]"
            href="/terms"
          >
            Terms of Service
          </a>
          <a
            className="text-sm text-[#64748b] hover:text-[#00255a]"
            href="/contact"
          >
            Contact Support
          </a>
        </footer>
      </main>
    </div>
  );
}

function FloatingInput(
  {
    type,
    label,
    value,
    onChange,
    required,
  } /*: { type: string; label: string; value: string; onChange: (v: string) => void; required?: boolean }*/,
) {
  return (
    <div className="relative">
      <input
        type={type}
        placeholder=" "
        required={required}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="peer w-full h-14 px-4 border border-[#e2e8f0] rounded-lg focus:ring-2 focus:ring-[#00255a]/10 focus:border-[#00255a] outline-none transition-all"
      />
      <label
        className="absolute left-4 top-4 text-[#64748b] text-base transition-all pointer-events-none
        peer-focus:-top-2.5 peer-focus:left-3 peer-focus:text-xs peer-focus:text-[#1e3c72] peer-focus:bg-white peer-focus:px-1
        peer-[:not(:placeholder-shown)]:-top-2.5 peer-[:not(:placeholder-shown)]:left-3 peer-[:not(:placeholder-shown)]:text-xs peer-[:not(:placeholder-shown)]:bg-white peer-[:not(:placeholder-shown)]:px-1"
      >
        {label}
      </label>
    </div>
  );
}

function SubmitButton(
  {
    loading,
    label,
    icon,
  } /*: { loading: boolean; label: string; icon: string }*/,
) {
  return (
    <button
      type="submit"
      disabled={loading}
      className="w-full h-14 text-white font-semibold rounded-lg shadow-md flex items-center justify-center gap-2 transition-transform hover:scale-[1.02] disabled:opacity-60"
      style={{
        background:
          "linear-gradient(135deg, #1e3c72 0%, #2a5298 60%, #ff7b7b 100%)",
      }}
    >
      {loading ? "Please wait..." : label}
      {!loading && (
        <span className="material-symbols-outlined text-base">{icon}</span>
      )}
    </button>
  );
}
